// import $ from "jquery";
// import owlCarousel from "owl.carousel";
import { $, owlCarousel } from "./imports";

const servicesHome = () => {
    if($('.service-home__list').length > 0){
        let $servicesHomeCarousel = $('.service-home__list').addClass('owl-carousel').owlCarousel({
            nav: false,
            dots: true,
            margin: 16,
            autoWidth: true,
            navText: [
                '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M15.514,6l1.627,1.627-5.285,5.3,5.285,5.3-1.627,1.627L8.59,12.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>',
                '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M10.217,6,8.59,7.627l5.285,5.3L8.59,18.22l1.627,1.627,6.923-6.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>'
            ],
            rewind: true,
            loop: true,
            // center: true,
            responsive: {
                768: {
                    nav: true,
                } 
            },
            // onChanged: showHidePrevNav
        });

        // function showHidePrevNav(event){
        //     let currentIndex = event.item.index;
        //     let $prevBtn = $servicesHomeCarousel.find('.owl-nav button.owl-prev');
    
        //     if(currentIndex >=  1){
        //         $prevBtn.css('display', 'flex');
        //     }else{
        //         $prevBtn.css('display', 'none');
        //     }

        // }
    
        $servicesHomeCarousel.on("changed.owl.carousel", (event) => {
            let currentIndex = event.item.index;
            let $prevBtn = $servicesHomeCarousel.find('.owl-nav button.owl-prev');
    
            if(currentIndex >=  1){
                $prevBtn.css('display', 'flex');
            }else{
                $prevBtn.css('display', 'none');
            }
        });
    }
}

export default servicesHome;